import { FC } from 'react';

import { DATA_SOURCE } from 'utils/types';

import BaseCustomFieldsForm from './BaseCustomFieldsForm';

const CompanyCustomFieldsForm: FC = () => (
  <BaseCustomFieldsForm source={DATA_SOURCE.COMPANY} />
);

export default CompanyCustomFieldsForm;
